export default "__VITE_ASSET__DnlL_jor__"